// import React, { useEffect, useRef } from 'react';
// import './About.css';

// const About = () => {
//   const sectionRef = useRef(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add('visible');
//           } else {
//             entry.target.classList.remove('visible'); 
//           }
//         });
//       },
//       { threshold: 0.2 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <section className="about-section" id="about" ref={sectionRef}>
//       <div className="about-blob"></div> 
      
//       <div className="about-wrapper">
//         <div className="about-header animate-item">
//           <span className="sub-tag">Who We Are</span>
//           <h2>About <span>The Doctor At Home</span></h2>
//           <div className="fancy-line"></div>
//         </div>

//         <div className="about-grid">
//           <div className="about-text-card animate-item delay-1">
//             <p>
//               The Doctor At Home is a pioneering <strong>home healthcare service</strong> that 
//               connects you with certified medical professionals for <strong>in-home consultations</strong>. 
//               We cater to chronic care patients, seniors, new mothers, and anyone seeking 
//               the comfort of <strong>home-based healthcare</strong>.
//             </p>
//           </div>

//           <div className="about-text-card animate-item delay-2">
//             <p>
//               Our Android app offers <strong>real-time doctor tracking</strong>, easy scheduling, 
//               and <strong>secure payments</strong>—eliminating long waits and travel hassles. 
//               Experience <strong>quality medical care</strong> right at your doorstep.
//             </p>
//           </div>
//         </div>

//         <div className="founder-box animate-item delay-3">
//           <div className="founder-badge">Founder</div>
//           <h3>Dr. Hridaynath Mangesh Lad</h3>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default About;




import React, { useEffect, useRef } from 'react';
import './About.css';

const About = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('show');
        } else {
          entry.target.classList.remove('show'); // Har baar scroll par animate hoga
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="about-section" id="about" ref={sectionRef}>
      <div className="about-container">
        <div className="about-header">
          <h2>About <span>The Doctor At Home</span></h2>
          <div className="underline"></div>
        </div>

        <div className="about-content">
          <p className="fade-text">
            The Doctor At Home is a pioneering <strong>home healthcare service</strong> that connects you with certified medical professionals for <strong>in-home consultations</strong>. We cater to chronic care patients, seniors, new mothers, and anyone seeking the comfort of <strong>home-based healthcare</strong>.
          </p>
          
          <p className="fade-text delay-short">
            Our Android app offers <strong>real-time doctor tracking</strong>, easy scheduling, and <strong>secure payments</strong>—eliminating long waits and travel hassles. Experience <strong>quality medical care</strong> right at your doorstep.
          </p>

          <div className="founder-info fade-text delay-long">
            <h3>Founder: <span>Dr. Hridaynath Mangesh Lad</span></h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;